import { SelectOption } from './Select'

export const getSelectOptionValue = (option?: SelectOption | string) => {
  if (!option) {
    return undefined
  }

  if (typeof option === 'string') {
    return option
  }

  return option.value
}
